import { createContext, useContext } from "react";
import { DEFAULT_DELAYED_ACTION_TOAST_CONTEXT } from "./constant";
import { DelayedActionToastContextType } from "./types";

const DelayedActionToastContext = createContext<DelayedActionToastContextType>(
    DEFAULT_DELAYED_ACTION_TOAST_CONTEXT
);

/**
 * Hook to access DelayedActionToast context
 * Throws error if used outside provider
 */
export const useDelayedActionToast = (): DelayedActionToastContextType => {
    const context = useContext(DelayedActionToastContext);
    if (!context) {
        throw new Error("useDelayedActionToast must be used within a DelayedActionToastProvider");
    }
    return context;
};

export { DelayedActionToastContext };
